// extracted by mini-css-extract-plugin
export default {"show-more":"ShowMoreButton_show-more__47aDh"};